import { render, staticRenderFns } from "./SuperVCode.vue?vue&type=template&id=c2edfa9a&scoped=true"
import script from "./SuperVCode.vue?vue&type=script&lang=js"
export * from "./SuperVCode.vue?vue&type=script&lang=js"
import style0 from "./SuperVCode.vue?vue&type=style&index=0&id=c2edfa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2edfa9a",
  null
  
)

export default component.exports